import ScrollContainer from './ScrollContainer.vue';

export default ScrollContainer;
